<div class="error-container">
  @if (errorMessageKey()) {
    <tui-error class="error-message" [error]="errorMessageKey() | translate"></tui-error>
  }
</div>
